const EMPTY_BODY_HEIGHT = 74;
const SEARCHING_SKELETON_ROWS = 3;
const DEFAULT_VISIBLE_ITEMS_LENGTH = 6;
const DEFAULT_ROW_HEIGHT = 39;

/**
 * @param {object} params
 * @param {number} params.itemsLength
 * @param {number} [params.rowHeight]
 * @param {boolean} [params.singleChose]
 * @param {number} [params.visibleItemsLength]
 * @param {boolean} [params.isSearching]
 * @returns {number}
 */
export default function getDropdownBodyHeight({
  itemsLength,
  rowHeight,
  singleChose,
  visibleItemsLength,
  isSearching,
}) {
  const row = rowHeight || DEFAULT_ROW_HEIGHT;
  const maxVisibleItems = visibleItemsLength ?? DEFAULT_VISIBLE_ITEMS_LENGTH;

  if (isSearching) {
    return row * SEARCHING_SKELETON_ROWS;
  }

  if (itemsLength === 0) {
    return EMPTY_BODY_HEIGHT;
  }

  if (itemsLength > maxVisibleItems) {
    return row * maxVisibleItems;
  }

  if (singleChose) {
    return (itemsLength + 1) * row;
  }

  return itemsLength * row;
}

export { SEARCHING_SKELETON_ROWS };
